import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Favorite = () => {
  const {
    showModal,
    isLoading,
    setShowModal,
    selectedCompany,
    updateCompany2Favorite,
  } = React.useContext(Context.CompanyScreen);

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "FAVORITE"}
        label={'علاقندی‌ها'}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedCompany?.companyInformation?.companyName}
                avatar={selectedCompany?.avatar}
                isBlock={
                  !selectedCompany?.companyInformation?.approved?.isApproved
                }
                phoneNumber={selectedCompany?.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => updateCompany2Favorite!(selectedCompany?._id)}
                title={selectedCompany?.companyInformation?.isFavorite ? 'خارج کردن' : 'اضافه کردن'}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Favorite;
